import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Venta } from '../../../models/venta';
import { VentaListModalComponent } from '../../../components/modals/venta-list-modal/venta-list-modal.component';
import * as numeral from 'numeral';
import { VentaDetalle } from '../../../models/venta_detalle';
import { ImpuestoService } from '../../../services/impuesto.service';
import { Impuesto } from '../../../models/impuesto';
import { Retencion } from '../../../models/retencion';
import { RetencionDetalle } from '../../../models/retencion_detalle';
import { ParametroService } from '../../../services/parametro.service';
import { VentaService } from '../../../services/venta.service';
import { SessionService } from '../../../services/session.service';
import { Validation } from '../../../config/validation';
//import { ComprobanteService } from '../../../services/comprobante.service';
import { SweetMessage } from '../../../config/sweet-message';
import { RetencionService } from '../../../services/retencion.service';
import * as moment from 'moment';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';
import * as xml2js from 'xml2js';
import { resolve } from 'url';
import { UtilsService } from '../../../services/utils.service';
import { VentaFilterModalComponent } from '../../modals/venta-filter-modal/venta-filter-modal.component';
import { IfObservable } from 'rxjs/observable/IfObservable';
import { RetencionRentaModalComponent } from '../../modals/retencion-renta-modal/retencion-renta-modal.component';
import { PeriodoContableService } from '../../../services/periodo-contable.service';
import { ParametroContabilidadService } from '../../../services/parametro-contabilidad.service';
import { PeriodoContable } from '../../../models/periodo-contable';
import { ParametroContabilidad } from '../../../models/parametro-contabilidad';
import { AsientoContable } from '../../../models/asiento-contable';
import { AsientoContableDetalle } from '../../../models/asiento-contable-detalle';
@Component({
	selector: 'retenciones-add',
	templateUrl: './retenciones-add.component.html',
	styleUrls: ['./retenciones-add.component.css'],
	providers: [
		ImpuestoService, 
		ParametroService, 
		RetencionService, 
		ImpuestoPorcentajeService,
		VentaService,
		ParametroContabilidadService,
        PeriodoContableService,
	]
})
export class RetencionesAddComponent implements OnInit {
	public bsModalRef: BsModalRef;
	public venta: Venta;
	public retencion: Retencion;
	public retencion_detalle: Array<RetencionDetalle>;
	public impuestos: Array<any>;
	public parametrosImp: Array<any>;
	public validDateFecha: Boolean;
	public vl: Validation;
	public msgSweet: SweetMessage;
	public total: number;
	public base_subtotal: number;
	public base_iva: number;
	public loading = false;
	public fecha_emision;
	public impuesto_porcentaje_iva: Array<any>;
	public impuesto_porcentaje_renta: Array<any>;
	public file: File;
	public numero_decimales: number;
	public format_decimal: String;
	public calculo_decimales: number;
	public Mod_Cartera: string;
	public Mod_Contabilidad: string;
	public parametrosContabilidad: Array<ParametroContabilidad>;
	public periodoContable: PeriodoContable;
	public totalRenta: number;
	public totalIva: number;
	public mask: any;

	constructor(
		private modalService: BsModalService,
		public impuestoService: ImpuestoService,
		public parametroService: ParametroService,
		private ss: SessionService,
		//public comprobanteService: ComprobanteService,
		public retencionService: RetencionService,
		private impuestoPorcentajeService: ImpuestoPorcentajeService,
		public ventaService: VentaService,
		public utils: UtilsService,
		private parametroContabilidadService: ParametroContabilidadService,
        private periodoContableService: PeriodoContableService,
	) {
		this.venta = new Venta();
		this.retencion = new  Retencion();
		this.retencion_detalle = [];
		this.impuestos = [];
		this.parametrosImp = [];
		this.vl = new Validation();
		this.msgSweet = new SweetMessage();
		this.total = 0;
		this.base_iva = 0;
		this.base_subtotal = 0;
		this.fecha_emision = moment(this.fecha_emision);
		this.impuesto_porcentaje_iva = [];
		this.impuesto_porcentaje_renta = [];
		this.numero_decimales = 2;
		this.calculo_decimales = 2;
		this.format_decimal = "0,0.00";
		this.Mod_Cartera = this.ss.getData("mod_cartera");
		this.Mod_Contabilidad = this.ss.getData("mod_contabilidad");
		this.parametrosContabilidad = [];
		this.periodoContable = new PeriodoContable();
		this.totalRenta = 0;
		this.totalIva = 0;
		this.mask = [ /[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/,/\d/,/\d/,/\d/,/\d/,/\d/,];
		this.venta.fecha_emision = moment();
	}

	ngOnInit() {
		let p1 = this.getImpuestos();
		let p2 = this.getParametros();
		let p3 = this.getImpuestoPorcentaje(2);
		let p4 = this.getParamNumeroDecimales();
		let p5 = this.getImpuestoPorcentaje(1);
		let p6 = this.getParametroContabilidadRetenciones();
		this.loading = true;
		Promise.all([p1,p2,p3,p4,p5,p6]).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}

	getImpuestos(){
		return new Promise((resolve, reject) => {
			this.impuestoService.getAll().subscribe(
				res => {
					let impuestos = [];
					impuestos = res.data;
					let result= impuestos.filter(i=>i.id!='4');
					this.impuestos = result;
					resolve(true);
				},
				err => {
					this.impuestos = [];
					reject();
				}
			);
		});
	}

	getImpuestoPorcentaje(impuesto_id){
		let qs = "?impuesto_id=" + impuesto_id+"&is_tarifa=0&is_vigente=1";
		return new Promise((resolve, reject) => {
			this.impuestoPorcentajeService.getAll(qs).subscribe(
				res => {
					if( res.data[0].impuesto_id == 2){
						this.impuesto_porcentaje_iva = res.data;
					}else{
						this.impuesto_porcentaje_renta = res.data;
					}
					
					resolve(true);
				}, err => {
					this.impuesto_porcentaje_iva = [];
					this.impuesto_porcentaje_renta = [];
					reject();
				}
			);
		});
	}

	getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
                    this.format_decimal = "0,0." + digitos
                    resolve(true);
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
    }

    get formatDecimal(){
        return this.format_decimal;
    }

	getParametros(){
		return new Promise((resolve, reject) => {
			this.parametroService.getAll("?in[id]=3,4,5,6").subscribe(
				res => {
					this.parametrosImp = res.data;
					resolve(true);
				},
				err => {
					this.parametrosImp = [];
					reject();
				}
			);
		});
	}

	getPeriodoActual(){
        return new Promise((resolve, reject) => {
            let qs = "?periodo=" + moment(this.retencion.fecha_emision.toString()).format('YYYY');
            this.periodoContableService.getPeriodoActual(qs).subscribe(
                res => {
                    this.periodoContable = res;
                    resolve(true);
                },
                err => {
                    reject(err);
                }
            );
        });
    }

    getParametroContabilidadRetenciones(){
        return new Promise((resolve, reject) => {
            let qs = "?in[id]=33,34,35,36&embed=cuentacontable";
            if( this.Mod_Cartera && this.Mod_Contabilidad ) {
                this.parametroContabilidadService.getAll(qs).subscribe(
                    res => {
                        this.parametrosContabilidad = res.data;
                        let is_confirmedParametros = true;
                        this.parametrosContabilidad.forEach(parametroContabilidad => {
                            if( parametroContabilidad.cuenta_contable_id == null ){
                                is_confirmedParametros = false;
                                return false;
                            }
                        });
                        if(!is_confirmedParametros){
                            this.msgSweet.showMessage('error-message', "Por favor, confirmar los parámetros de las cuentas contables.");
                        }
                        resolve(true);
                    },
                    err => {
                        reject(err);
                    }
                );
            }else{
				resolve(true);
			}
        });
	}

	getNumeroDocumento(event){
		let numero_documento = event.target.value;
		this.retencion.serie = numero_documento.split('-')[0];
		this.retencion.punto_emision = numero_documento.split('-')[1];
		this.retencion.secuencial = numero_documento.split('-')[2];
	}
	
	setValueAsientoContable(){
        
        let asientoContable = new AsientoContable();
        let asientoContableCobros = new AsientoContable();
        asientoContable.fecha_emision = this.retencion.fecha_emision;
        asientoContable.tipocomprobante = this.retencion.tipocomprobante;
        asientoContable.tipo_comprobante_id = this.retencion.tipo_comprobante_id.toString();
        asientoContable.periodo_contable_id = this.periodoContable.id;
        asientoContable.numero_documento = this.retencion.serie + '-' + this.retencion.punto_emision + '-' + this.retencion.secuencial;
        asientoContable.descripcion = this.venta.cliente.nombre_comercial;
        asientoContable.empresa_id = this.retencion.empresa_id;
        asientoContable.usuario_id = this.retencion.usuario_id;
		asientoContable.total = this.retencion.total;
		asientoContable.status = 'A';
        asientoContableCobros.fecha_emision = this.retencion.fecha_emision;
        asientoContableCobros.tipocomprobante = this.retencion.tipocomprobante;
        asientoContableCobros.tipo_comprobante_id = this.retencion.tipo_comprobante_id.toString();
        asientoContableCobros.periodo_contable_id = this.periodoContable.id;
        asientoContableCobros.numero_documento = this.retencion.serie + '-' + this.retencion.punto_emision + '-' + this.retencion.secuencial;
        asientoContableCobros.descripcion = this.venta.cliente.nombre_comercial;
        asientoContableCobros.empresa_id = this.retencion.empresa_id;
        asientoContableCobros.usuario_id = this.retencion.usuario_id;
        asientoContableCobros.total = this.retencion.total;
        asientoContableCobros.status = 'A';
        this.parametrosContabilidad.forEach(parametroContabilidad => {
            let asientoContableDetalle = new AsientoContableDetalle;
            asientoContableDetalle.empresa_id = asientoContable.empresa_id;
            asientoContableDetalle.usuario_id = asientoContable.usuario_id;
            asientoContableDetalle.haber = 0;

            if( parametroContabilidad.id == "35" && this.totalRenta > 0 ) {
				parametroContabilidad.tipo_saldo = "D";
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.totalRenta:0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.totalRenta:0;
                asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
                asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable; 
				if(parametroContabilidad.tipo_saldo == 'H'){
					asientoContable.detalle.push(asientoContableDetalle);
				}else{
					asientoContable.detalle.unshift(asientoContableDetalle); 
				}      
            }
            
            if( parametroContabilidad.id == "36" && this.totalIva > 0) {
				parametroContabilidad.tipo_saldo = "D";
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.totalIva:0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.totalIva:0;
                asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
                asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
				if(parametroContabilidad.tipo_saldo == 'H'){
					asientoContable.detalle.push(asientoContableDetalle);
				}else{
					asientoContable.detalle.unshift(asientoContableDetalle); 
				}     
			}
			
			if( parametroContabilidad.id == "33" && this.totalRenta > 0 ) {
				parametroContabilidad.tipo_saldo = "H";
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.totalRenta:0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.totalRenta:0;
                asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
                asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
				if(parametroContabilidad.tipo_saldo == 'H'){
					asientoContable.detalle.push(asientoContableDetalle);
				}else{
					asientoContable.detalle.unshift(asientoContableDetalle); 
				}     
			}
			
			if( parametroContabilidad.id == "34" && this.totalIva > 0 ) {
				parametroContabilidad.tipo_saldo = "H";
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.totalIva:0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.totalIva:0;
                asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
                asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
				if(parametroContabilidad.tipo_saldo == 'H'){
					asientoContable.detalle.push(asientoContableDetalle);
				}else{
					asientoContable.detalle.unshift(asientoContableDetalle);   
				}     
            }

           
            
        });
        this.retencion.asientosContables.push(asientoContable);
    }

	onIniDate() {
		let today = new Date();
		let dd = today.getDate();
		let mm = today.getMonth() + 1; //January is 0!
		let dia = "";
		let mes = "";

		var yyyy = today.getFullYear();
		dia = "" + dd;
		mes = "" + mm;
		if (dd < 10) {
			dia = "0" + dd;
		}
		if (mm < 10) {
			mes = "0" + mm;
		}
		let today2 = dia + '/' + mes + '/' + yyyy;
		this.retencion.fecha_emision = today2;
		//this.retencion.fecha_caducidad = today2;
	}

	onValidDateFecha(fecha){
        return this.validDateFecha = this.vl.validDate(fecha.toString());
    }

	onSearch(id){
		let qs = "&notin[cliente_id]=1";
		const initialState = { qs, numero_decimales: this.numero_decimales };
		this.bsModalRef = this.modalService.show(VentaFilterModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.onSelectedRow.take(1).subscribe(venta => {
			this.ventaService.getById(venta.id, "?embed=tipocomprobante?embed=tipoidentificacion,bodega,cliente,guiaremision,retencion,detalle?embed=producto").subscribe(res=>{
				this.venta = res.data; 
			
			},err=>{

			});

			// if( venta.retencion ){
			// 	this.msgSweet.showMessage('error-message','La factura seleccionada ya tiene una retención');
			// }else{
			// 	this.venta = venta;
			// 	//this.calcularRetencion();
			// }
		});
	}

	calcularItemRetencion(impuesto_id, parametro_id, subtotal){
		let retencion_detalle;
		retencion_detalle = new RetencionDetalle();
		retencion_detalle.base_imponible = subtotal;
		retencion_detalle.impuesto_id = impuesto_id;
		retencion_detalle.impuesto = this.impuestos.filter(x => x.id===impuesto_id)[0];
		retencion_detalle.porcentaje = this.parametrosImp.filter(x => x.id===parametro_id)[0].valor;
		retencion_detalle.total = retencion_detalle.base_imponible * (retencion_detalle.porcentaje / 100);
		//retencion_detalle.total = Math.round(retencion_detalle.total * 100) / 100;
		retencion_detalle.empresa_id = this.ss.getData('empresa_id');
		retencion_detalle.sucursal_id = this.ss.getData('sucursal_id');
		retencion_detalle.usuario_id = this.ss.getData('usuario_id');

		this.total += retencion_detalle.total;

		this.retencion_detalle.push(retencion_detalle);
	}
	
	calcularRetencion(){
		let subtotal_servicio = 0;
		let subtotal_producto = 0;
		let iva_servicio = 0;
		let iva_producto = 0;
		this.total = 0;

		this.venta.detalle.forEach((venta_detalle: VentaDetalle) => {
			// if( venta_detalle.producto.es_servicio ){
			if( venta_detalle.producto.tipo_producto_id ){
				subtotal_servicio += parseFloat(venta_detalle.subtotal.toString());
				iva_servicio += parseFloat(venta_detalle.iva.toString());
			}else{
				subtotal_producto += parseFloat(venta_detalle.subtotal.toString());
				iva_producto += parseFloat(venta_detalle.iva.toString());
			}
		});

		//let retencion_detalle;
		this.retencion_detalle = [];
		let vendedor_obligado = this.ss.getData('es_obligado');
		//let vendedor_contribuyente = this.ss.getData('es_contribuyente');

		let cliente_obligado = this.venta.cliente.es_obligado;
		let cliente_contribuyente = this.venta.cliente.es_contribuyente;
		
		if( vendedor_obligado === "1" ){
			if( cliente_obligado ){
				// Calcular retencion en RENTA
				if( subtotal_producto ) this.calcularItemRetencion(1,3,subtotal_producto);
				if( subtotal_servicio ) this.calcularItemRetencion(1,4,subtotal_servicio);

				if( cliente_contribuyente ){
					// Calcular retencion en IVA
					if( subtotal_producto ) this.calcularItemRetencion(2,5,iva_producto);
					if( subtotal_servicio ) this.calcularItemRetencion(2,6,iva_servicio);
				}
			}
		}else{
			if( cliente_obligado ){
				// Calcular retencion en RENTA
				if( subtotal_producto ) this.calcularItemRetencion(1,3,subtotal_producto);
				if( subtotal_servicio ) this.calcularItemRetencion(1,4,subtotal_servicio);

				// Calcular retencion en IVA
				if( subtotal_producto ) this.calcularItemRetencion(2,5,iva_producto);
				if( subtotal_servicio ) this.calcularItemRetencion(2,6,iva_servicio);
			}
		}
	}

	onSubmit(){
		this.msgSweet.showMessage('delete-confirm-message', "¿Está seguro de confirmar la retención?").then(
			res => {
				this.setValueEntity();

				if( this.Mod_Cartera && this.Mod_Contabilidad ){

                    this.getPeriodoActual().then(
                        res => {
                            this.setValueAsientoContable();
                            this.saveRetencion();   
                        }
                    );
                }else {
                    this.saveRetencion();   
                }
				
			}
		);
	}

	saveRetencion() {
		this.loading = true;
		this.retencionService.save(this.retencion,'?asiento=true').subscribe(
			res => {
				this.loading = false;
				this.msgSweet.showMessage('success-message', res.message);

				this.venta = new Venta();
				this.retencion = new  Retencion();
				this.retencion_detalle = [];
				this.total = 0;
				this.totalRenta = 0;
				this.totalIva = 0;

				this.onIniDate();
			},
			err => {
				this.venta = new Venta();
				this.retencion = new  Retencion();
				this.retencion_detalle = [];
				this.total = 0;
				this.totalRenta = 0;
				this.totalIva = 0;

				this.onIniDate();
				this.loading = false;
				this.msgSweet.showMessage('error-message',err);
			}
		);
	}

	setValueEntity(){
		this.retencion.tipo = "V";
		this.retencion.total = this.total;
		this.retencion.numero_documento = this.retencion.serie + "-" + this.retencion.punto_emision + "-" + this.retencion.secuencial;
		this.retencion.documento_id = this.venta.id;

		this.retencion_detalle.forEach(detalle => {
			if(detalle.impuesto_id == '2'){
				this.base_iva += parseFloat(detalle.base_imponible.toString());
				this.totalIva += parseFloat(detalle.total.toString());
			}
			else{
				this.base_subtotal+= parseFloat(detalle.base_imponible.toString());
				this.totalRenta += parseFloat(detalle.total.toString());
			}
		});
		this.retencion.detalle = this.retencion_detalle;
		this.retencion.fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD");
		this.retencion.empresa_id = this.ss.getData('empresa_id');
		this.retencion.sucursal_id = this.ss.getData('sucursal_id');
		this.retencion.usuario_id = this.ss.getData('usuario_id');
	}

	getSubtotal(venta){
		let n = parseFloat(venta.subtotal_iva12) + parseFloat(venta.subtotal_iva0);
		return numeral(n).format(this.format_decimal);
	}

	recalcular(detalle_retencion){
		/*if( typeof event !== 'undefined' ){
			if( !event.target.value || event.target.value == 0 ){
				//detalle_retencion.porcentaje = 1;
			}else{
				//detalle_retencion.porcentaje = parseFloat(event.target.value);
			}
		}*/
		
		detalle_retencion.total = detalle_retencion.base_imponible * (detalle_retencion.porcentaje / 100);
		//detalle_retencion.total = Math.round(detalle_retencion.total * 100) / 100;
		detalle_retencion.total = this.utils.redondear(detalle_retencion.total, this.calculo_decimales);

		this.total = 0;
		this.retencion_detalle.forEach(detalle => {
			this.total += parseFloat(detalle.total.toString());
		});
	}

	recalcular2(){
		this.total = 0;
		this.retencion_detalle.forEach(detalle => {
			this.total += parseFloat(detalle.total.toString());
		});
	}

	isValidForm(){
		if(this.base_subtotal > 0 && this.base_subtotal < this.retencion.compra.subtotal){
			return false;
		}
		if(this.base_iva > 0 && this.base_iva < this.retencion.compra.iva){
			return false;
		}
		if( this.retencion.serie == undefined || this.retencion.serie.toString().trim().length === 0  ){
			return false;
		}
		if( this.retencion.punto_emision == undefined || this.retencion.punto_emision.toString().trim().length === 0  ){
			return false;
		}
		if( !this.retencion.numero_autorizacion ){
			return false;
		}
		if( this.retencion.secuencial == undefined || this.retencion.secuencial.toString().trim().length === 0  ){
			return false;
		}
		if( !this.venta.id ){
			return false;
		}
		if( this.retencion_detalle.length === 0 ){
			return false;
		}
		let b = false;
		this.retencion_detalle.forEach(item => {
			if( item.base_imponible.toString().trim().length < 1 || item.base_imponible.toString() === "0"){
				b = true;
			}
			if( item.codigo.toString().trim().length < 1 ){
				b = true;
			}
		});
		if( b ){
			return false;
		}

		if (this.retencion.numero_documento.toString().trim().length === 0) {
			return false;
		}
		return true;
	}

	onChangeImp(detalle: RetencionDetalle){
		detalle.codigo = "";
		detalle.total = 0;
		detalle.porcentaje = 0;
	}

	onDelete(i){
		this.retencion_detalle.splice(i, 1);
		this.recalcular2();
	}

	addDetalle(){
		this.retencion_detalle.push(new RetencionDetalle());
	}

	gerPeriodoFiscal(){
		return moment(this.fecha_emision).format("MM/YYYY");
	}

	onChangeValorImp(detalle: RetencionDetalle){
		let imp_sel = this.impuesto_porcentaje_iva.filter(x => x.codigo == detalle.codigo)[0];
		detalle.porcentaje = imp_sel.porcentaje;
		detalle.total = parseFloat(detalle.base_imponible.toString()) * (parseFloat(imp_sel.porcentaje.toString()) / 100);
		//detalle.total = Math.round(detalle.total * 100) / 100;
		detalle.total = this.utils.redondear(detalle.total, this.calculo_decimales);

		this.recalcular(detalle);
	}

	onEvento(detalle: RetencionDetalle, event?){
		if( detalle.codigo != "" ){
			if( event ){
				event.stopPropagation();
				if (event.key === "Enter" ) {
					this.obtenerPorcentaje(detalle);
					
				}
			}else{
				this.obtenerPorcentaje(detalle);
			}	
		}else{
			detalle.porcentaje = 0;
		}
	}

	obtenerPorcentaje(detalle: RetencionDetalle){
		let imp_sel = this.impuesto_porcentaje_renta.filter(x => x.codigo.toLowerCase() === detalle.codigo.toLowerCase())[0];
		if( imp_sel ){
			detalle.porcentaje = imp_sel.porcentaje;	
		}else{
			this.msgSweet.showMessage('error-message', "No existe el código indicado");
			detalle.codigo = "";
			detalle.porcentaje = 0;            
		}
		
	}

	openModalRetencionRenta(detalle){
		
		const initialState = {impuesto_porcentaje_renta: this.impuesto_porcentaje_renta};
		this.bsModalRef = this.modalService.show(RetencionRentaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.sendImpuestoRenta.take(1).subscribe(impuesto_renta => {
			detalle.codigo = impuesto_renta.codigo;
			detalle.porcentaje = impuesto_renta.porcentaje;
			//this.loading = true;
			this.recalcular(detalle);
			
		});
		
	}

	uploadXLM(event){
		this.file = event.target.files[0];
		let fr = new FileReader();

		let promise = new Promise((resolve, reject) => {
			fr.onload = (e) =>{
				let xml = fr.result;
	
				xml2js.parseString( xml, function (err, result) {
					if( err ) reject(err);
					resolve(result);
				});
			}
		});

		promise.then(
			result => {
				//VALIDACION
				this.retencion = new Retencion();
				this.retencion_detalle = [];

				//SECCION DE RETENCION
				this.retencion.serie = result['autorizacion']['comprobante'][0]['comprobanteRetencion'][0]['infoTributaria'][0]['estab'][0];
				this.retencion.punto_emision = result['autorizacion']['comprobante'][0]['comprobanteRetencion'][0]['infoTributaria'][0]['ptoEmi'][0];
				this.retencion.secuencial = result['autorizacion']['comprobante'][0]['comprobanteRetencion'][0]['infoTributaria'][0]['secuencial'][0];
				this.retencion.numero_autorizacion = result['autorizacion']['comprobante'][0]['comprobanteRetencion'][0]['infoTributaria'][0]['claveAcceso'][0];
				this.fecha_emision = result['autorizacion']['comprobante'][0]['comprobanteRetencion'][0]['infoCompRetencion'][0]['fechaEmision'][0];
				this.retencion.fecha_emision = this.fecha_emision;
				//SECCION DE COMPROBANTE RETENIDO

				let impuesto = [];
				impuesto = result['autorizacion']['comprobante'][0]['comprobanteRetencion'][0]['impuestos'];
				
				impuesto.forEach(element => {				
					let retencion_detalle;
					retencion_detalle = new RetencionDetalle();

					retencion_detalle.impuesto_id = element['impuesto'][0]['codigo'][0];
					retencion_detalle.impuesto = this.impuestos.filter(x => x.id===retencion_detalle.impuesto_id)[0];
					retencion_detalle.porcentaje = element['impuesto'][0]['porcentajeRetener'][0];					
					retencion_detalle.base_imponible = element['impuesto'][0]['baseImponible'][0];
					retencion_detalle.codigo = element['impuesto'][0]['codigoRetencion'][0];
					retencion_detalle.total = element['impuesto'][0]['valorRetenido'][0];

					let numDocSustento = element['impuesto'][0]['numDocSustento'][0];
					let serie = numDocSustento.substring(0,3);
					let punto_emision = numDocSustento.substring(3,6);
					let secuencial = parseInt(numDocSustento.substring(6));

					let qs = "?serie="+serie+"&punto_emision="+punto_emision+"&secuencial="+secuencial+"&embed=bodega,tipocomprobante,detalle,cliente";
					
					this.ventaService.getAll(qs).subscribe(
						res => {
								this.venta = res.data[0];
						},
						err => {
							console.log('ventaService-Error', err);
						}
					);

					this.retencion_detalle.push(retencion_detalle);
				});				
			},
			err => {
				console.log(err);
			}
		);

		

		fr.readAsText(this.file,'ISO-8859-4');


	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/retenciones-add/retenciones-add.component.ts